import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu';
import { resetFlags } from '../../redux/actions/flag-actions';
import { signOutUser } from '../../redux/actions/user-actions';
import { firebase } from '../../firebase';

class MobileMenu extends Component {
  logout = () => {
    if (this.props.flagsSearch) {
      this.props.dispatch(resetFlags());
    }
    firebase.auth.signOut().then(function() {
      signOutUser();
    });
    return true;
  };

  render() {
    return (
      <React.Fragment>
        <Menu width={'%75'}>
          <a id="dashboard" className="menu-item" href="/dashboard">
            Dashboard
          </a>
          <a id="flags" className="menu-item" href="/flags">
            Search Flags
          </a>
          <a id="myprofile" className="menu-item" href="/myprofile">
            My Profile
          </a>
          <a id="logout" className="menu-item" onClick={this.logout}>
            Log Out
          </a>
        </Menu>
      </React.Fragment>
    );
  }
}

export default MobileMenu;
